module.exports = __webpack_public_path__ + "abd002adae9fc13fd4b570ee2bb327f4.pdf";